import { NgModule } from '@angular/core';

import { BaseModule } from '../shared/base.module';

import { SelfEvaluationService } from './self-evaluation.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DialogModule } from '../dialog/dialog.module';
import { RepeatSelfEvaluationRoutesModule } from './repeat-self-evaluation.routes';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
    imports: [
        BaseModule,
        RepeatSelfEvaluationRoutesModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        DialogModule
    ],
    declarations: [
    ],
    providers: [
        SelfEvaluationService
    ]
})
export class RepeatSelfEvaluationModule {
}
